import { useState, useMemo, useEffect } from "react";
import { Fragment } from "react";

import ComponentLightCodeModal from "./ComponentLightCodeModal";

import { getLabel, getLanguage } from "../../tools/Dictionary";

import { FaRegCircle } from "react-icons/fa";
import { MdOutlineLightMode, MdOutlineMotionPhotosOff } from "react-icons/md";
import { LiaHandPointer } from "react-icons/lia";
import "./Component.css";

const ComponentLightCode = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Data = props.Data;
  const Value = props.Value;
  const Edit = props.Edit;
  const Error = props.Error;
  const Compact = props.Compact;
  const OnChangeValue = props.OnChangeValue;



  //Init
  const initValue = useMemo(() => {
    let initForm = '';

    for (let i = 0; i < Data.data.lightAmount; i++)
    {
      initForm += '_';
    }   

    return initForm;
  }, [Data.data.lightAmount]);

  //State
  const [form, setForm] = useState(!Edit && Value && Value.data ? Value.data : initValue);
  const [modal, setModal] = useState({
    display: false,
    index: -1,
    value: undefined
  });


  useEffect(() => {

    setForm(initValue);

  }, [initValue]);
  

  const onChangeLight = (_value) => {

    let currentForm = form.split('');

    currentForm[modal.index] = _value;

    setForm(currentForm.join(''));
    OnChangeValue(currentForm.join(''), Data);
    setModal({ display: false, index: -1, value: "" });

  };

  const displayIcon = (_value, _index) => {


    if (_value == "_" && form.indexOf("_") == _index) 
      return (
        <div className="component_light_item component_light_item_clicking" key={_index} onClick={() => setModal({ display: true, index: _index, value: _value })}
          title={getLabel("ConditionDesigner", "Edit the error code")}
          >
          <LiaHandPointer />
        </div>
      );
    
    if (_value == "X")
        return (
          <div className="component_light_item" 
            key={_index} 
            onClick={() => setModal({ display: true, index: _index, value: _value })} style={{ color: "#b30000" }}
            title={getLabel("ComponentEntity", "Light off")}
            >
            <MdOutlineMotionPhotosOff />
          </div>
        );

    if (_value == "O")
      return (
        <div className="component_light_item" 
        key={_index} 
        onClick={() => setModal({ display: true, index: _index, value: _value })} style={{ color: "#008000" }}
        title={getLabel("ComponentEntity", "Light on")}
        >
          <FaRegCircle  />
        </div>
      );

    if (_value == "F")
      return (
        <div className="component_light_item" 
        key={_index} 
        onClick={() => setModal({ display: true, index: _index, value: _value })} 
        style={{ color: "#e68a00" }}
        title={getLabel("ComponentEntity", "Flashing light")}
        >
          <MdOutlineLightMode />
        </div>
      );

    return <div className="component_light_item" onClick={() => setModal({ display: true, index: _index, value: _value })} title={getLabel("ConditionDesigner", "Edit the error code")}  />;

  };


  let listForm = form.split('');



  return (
    <Fragment>
      {!Edit && modal.display &&
        <ComponentLightCodeModal 
          Value={modal.value}
          OnChangeLight={onChangeLight}
          OnCloseModal={() => setModal({display: false, index: -1, value: ""})}
        />
      }
      {!Compact && 
        <Fragment>
          <div className="component_row_label" style={Data.data.textStyle}>
            {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
          </div>
          <div className="component_legend_cont">
            <div className="component_legend_title">
              {getLabel("ComponentEntity", "Legend")}
            </div>
            <div className="component_legend_item" style={{ color: "#b30000"}}>
              <div className="component_legend_item_icon">
                <MdOutlineMotionPhotosOff />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Light off")}
              </div>
            </div>
            <div className="component_legend_item" style={{ color: "#008000" }}>
              <div className="component_legend_item_icon">
                <FaRegCircle />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Light on")}
              </div>
            </div>
            <div className="component_legend_item" style={{ color: "#e68a00" }}>
              <div className="component_legend_item_icon">
                <MdOutlineLightMode />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Flashing light")}
              </div>
            </div>
          </div>
        </ Fragment>
      }
      <div className="component_light_cont" style={{marginBottom: "10px"}}>
        {listForm.map((f, index) => (
          <Fragment key={index} >
            {displayIcon(f, index)}
          </Fragment>
        ))}
      </div>
      <div className="component_row_error">
        {Error}
      </div>
    </Fragment>
  );

};

export default ComponentLightCode